export const URL = 'system-setting';
export const URL_TOGGLE = 'system-setting/toggle';
export const URL_SET_VOTE_SELECTION = 'system-setting/set-vote-selections';
export const URL_SET_REPLIED_MESSAGE = 'system-setting/set-replied-messages';

export const SET_LOADING = 'SET_CONFIG_SYSTEM_LOADING';
export const GET_INFO = 'GET_CONFIG_SYSTEM_INFO';
export const SET_STATUS = 'SET_STATUS_SYSTEM';
